import React from 'react';

const AlertsContext = React.createContext();

export default AlertsContext;
